import axios from "axios";
import { setToken } from "./token";

const baseURL = "/api/authenticate";

const authAPI = axios.create({
  baseURL,
  headers: { "Content-Type": "application/json" },
});

export const login = async (username, password) => {
  const response = await authAPI.post("/login", { username, password });
  const token = response.data.accessToken;
  setToken(token);
  return token;
};
